import { Button } from '@cian/ui-kit';
import * as React from 'react';
import { useButtonDisabled, useButtonText, useSubmitClickHandler } from '../hooks';

interface IAddNewCardButtonProps {
  buttonRef?: React.Ref<HTMLDivElement>;
}

export const AddNewCardButton: React.FC<IAddNewCardButtonProps> = ({ buttonRef }) => {
  const buttonText = useButtonText();
  const handleClick = useSubmitClickHandler();
  const isButtonDisabled = useButtonDisabled();

  return (
    <div ref={buttonRef}>
      <Button onClick={handleClick} size="L" disabled={isButtonDisabled} fullWidth>
        {buttonText}
      </Button>
    </div>
  );
};
